(function($) {
// TODO: Is this used still?
  $(document).ready(function () {
    $('body > #wrapper + .form-container form').addClass('modal fade').modal('show');
  });

  $(document).on('submit', 'body > #wrapper + .form-container form', function() {
    let submitted;
    $(document).ajaxSuccess(function() {
      submitted = true;
      
      if (submitted) {
        $('body > #wrapper + .form-container form').modal('hide');
      }
    });
  });

  $(document).on('click', 'body > #wrapper + .form-container form .close', function() {
    $(this).closest('form').modal('show').modal('hide');
    $('.modal-backdrop').remove();
  });
  
})(jQuery)